import {IMailDialogDataChildren} from '@appModels/correo/correo';
import {Language} from '@appModels/store/settings/settings.model';
import {BuildDialogConfig} from '@appInterfaces/dialogs/BuildDialogConfig';
import {TranslocoService} from '@ngneat/transloco';

// DOCS: DATA PROPERTY CHANGES TO TYPE ANY SO THAT IT RECEIVES ANY INTERFACE FROM ANY DIALOG
export const buildDialogConfig = (data?: any): BuildDialogConfig => {
  return {
    backdropClass: 'mat-dialog-background',
    data,
    panelClass: 'mat-dialog-style',
  };
};

export const buildDialogChildrenContent = async (
  translateService: TranslocoService,
  language: Language,
): Promise<IMailDialogDataChildren> => {
  const contentTitle = await getTranslationByKey(
    translateService,
    'investigationTechnicalCommercial.details.investigationProduct.mailHeader',
    language,
  );
  const contentDescription = await getTranslationByKey(
    translateService,
    'investigationTechnicalCommercial.details.investigationProduct.messageToProvider',
    language,
  );

  return {
    contentDescription,
    contentTitle,
  };
};

const getTranslationByKey = async (
  translateService: TranslocoService,
  key: string,
  language: string,
): Promise<string> => {
  // Cargar el idioma si no está cargado
  await translateService.load(language).toPromise();
  const scopePath = `pendings/investigation-technical-commercial/${language}`;
  await translateService.load(scopePath).toPromise();
  // Obtener la traducción como un string
  return await translateService.selectTranslate(key, {}, language).toPromise();
};
